// extracted by mini-css-extract-plugin
export default {"hotelRating":"ratingBadge-module__hotelRating__KmsN-","hotelRatingRight":"ratingBadge-module__hotelRatingRight__g8s1Z","hotelRatingLeft":"ratingBadge-module__hotelRatingLeft__3V8Rd"};